import {v4 as uuidv4} from 'uuid';

const batchSize = 7;
const mutexLifetimeSeconds = 40;
const trackingIntervalSeconds = 60;

const localStorageKeyPrefix = "trackingEvent-";
const trackingMutexKey = "trackingMutex";

export const startTrackingQueue = () => {
    getSessionStartTime();
    const trackingIntervalMs = 1000 * trackingIntervalSeconds;
    setInterval(track, trackingIntervalMs);
    setupBeforeUnloadListener();
}

const setupBeforeUnloadListener = () => {
    window.addEventListener("beforeunload", (ev) => {
        ev.preventDefault();
        track(true);
    });
};

const getSessionStartTime = () => {
    const sessionStartTimeKey = "sessionStartTime";
    let time = sessionStorage.getItem(sessionStartTimeKey);
    if (time) {
        return (+time);
    }

    time = Date.now();
    sessionStorage.setItem(sessionStartTimeKey, String(time));
    return time;
}

export const pushTracking = (type, properties) => {
    const id = uuidv4();
    const now = Date.now();
    const trackingEvent =
        {
            type: type,
            properties: properties,
            time: now,
            id: id,
            sessionStartTime: getSessionStartTime()
        };
    const key = localStorageKeyPrefix + id;
    localStorage.setItem(key, JSON.stringify([trackingEvent]));
}

const track = (forceBatch = false) => {
    if (!getMutex()) return;

    const events = [];
    const keys = [];
    Object.keys(localStorage).filter(key => key.startsWith(localStorageKeyPrefix)).forEach(key => {
        const data = localStorage.getItem(key);
        keys.push(key);
        JSON.parse(data).forEach(event => events.push(event));
    });
    const postBatch = 0 < events.length && (forceBatch || batchSize <= events.length);
    if (postBatch) {
        keys.forEach(key => localStorage.removeItem(key));
        removeMutex();
        fetch("api/track/",
            {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify(events),
                keepalive: true
            })
            .then(() => {
            });
    }

    removeMutex();
}

const getMutex = () => {
    const now = Date.now();
    const mutex = localStorage.getItem(trackingMutexKey);
    if (mutex && now - (+mutex) < 1000 * mutexLifetimeSeconds) return false;
    localStorage.setItem(trackingMutexKey, now.toString());
    return true;
}

const removeMutex = () => {
    localStorage.removeItem(trackingMutexKey);
}